import { get } from 'lodash';

import { contractor as contractorFM } from '@src/app/formModels/eligibility/incomings.contractor';
import { employed as employedFM } from '@src/app/formModels/eligibility/incomings.employed';
import { notInPaid as notInPaidFM } from '@src/app/formModels/eligibility/incomings.notInPaid';
import { retired as retiredFM } from '@src/app/formModels/eligibility/incomings.retired';
import {
    selfEmployed as selfEmployedFM,
    selfEmployedLimitedCompany as selfEmployedLimitedCompanyFM,
    selfEmployedPartnership as selfEmployedPartnershipFM,
    selfEmployedSoleTrader as selfEmployedSoleTraderFM,
} from '@src/app/formModels/eligibility/incomings.selfEmployed';
import { isEqualStr } from '@src/shared/helpers';
import { getValidationSchema } from '@src/shared/helpers/input';
import { BasePropertyType } from '@src/ui/components/PropertyType/PropertyType';

export const updateState = (applicants: any, propertyDetails: any) => {
    // TODO move to from request
    // update hasSecondApplicant as its not returned from the BE
    if (!applicants[0].hasSecondApplicant) {
        applicants[0].hasSecondApplicant =
            applicants.length === 2 ? 'true' : 'false';

        if (applicants[1]) {
            applicants[1].hasSecondApplicant = false;
        }
    }

    // update propertyTypeBase as its not returned from the BE
    if (propertyDetails.propertyType?.includes(BasePropertyType.HOUSE)) {
        propertyDetails.propertyTypeBase = BasePropertyType.HOUSE;
    } else if (
        propertyDetails.propertyType?.includes(BasePropertyType.BUNGALOW)
    ) {
        propertyDetails.propertyTypeBase = BasePropertyType.BUNGALOW;
    } else if (propertyDetails.propertyType?.includes(BasePropertyType.FLAT)) {
        propertyDetails.propertyTypeBase = BasePropertyType.FLAT;
    }
};

export const validateIncomings = (data: any): boolean => {
    try {
        const employmentStatus = get(data, 'employmentStatus');

        let isValid = false;

        if (isEqualStr(employmentStatus, 'employed')) {
            const employedSchema = getValidationSchema(employedFM);
            removeValidationEmployed(employedSchema);
            isValid = !!employedSchema.validateSync(data);
        }

        if (isEqualStr(employmentStatus, 'self-employed')) {
            const selfEmployedSchema = getValidationSchema(selfEmployedFM);
            const isSelfEmployedValid = !!selfEmployedSchema.validateSync(data);
            if (!isSelfEmployedValid) return false;

            const selfEmployedType = get(data, 'selfEmployedType');

            if (isEqualStr(selfEmployedType, 'Limited company')) {
                const subSchema = getValidationSchema(
                    selfEmployedLimitedCompanyFM,
                );
                removeValidationSelfEmployed(subSchema);
                isValid = !!subSchema.validateSync(data);
            } else if (isEqualStr(selfEmployedType, 'Sole trader')) {
                const subSchema = getValidationSchema(selfEmployedSoleTraderFM);
                isValid = !!subSchema.validateSync(data);
            } else if (isEqualStr(selfEmployedType, 'Partnership')) {
                const subSchema = getValidationSchema(
                    selfEmployedPartnershipFM,
                );
                removeValidationSelfEmployed(subSchema);
                isValid = !!subSchema.validateSync(data);
            }
        }

        if (isEqualStr(employmentStatus, 'retired')) {
            const retiredSchema = getValidationSchema(retiredFM);
            isValid = !!retiredSchema.validateSync(data);
        }

        if (isEqualStr(employmentStatus, 'Not in paid employment')) {
            const notInPaidSchema = getValidationSchema(notInPaidFM);
            isValid = !!notInPaidSchema.validateSync(data);
        }

        if (isEqualStr(employmentStatus, 'contractor')) {
            const contractorSchema = getValidationSchema(contractorFM);
            removeValidationContractor(contractorSchema);
            isValid = !!contractorSchema.validateSync(data);
        }

        return isValid;
    } catch (_error) {
        return false;
    }
};

// These fields aren't returned from the BE and would cause validation to fail
const removeValidationEmployed = (schema: any) => {
    delete schema.fields.employment.fields.startMonth;
    delete schema.fields.employment.fields.startYear;
};

const removeValidationContractor = (schema: any) => {
    delete schema.fields.endMonth;
    delete schema.fields.endYear;
    delete schema.fields.startMonth;
    delete schema.fields.startYear;
};

const removeValidationSelfEmployed = (schema: any) => {
    delete schema.fields.month;
    delete schema.fields.year;
};

export const removeValidationProperty = (propertyFormItems: any) => {
    delete (propertyFormItems as any).otherOwnershipSchemeType;
};
